import * as React from 'react';
import ReactDOM from 'react-dom';
import { Button, BUTTON_TYPE } from '@bepure/tarkin';

interface Tile {
    title: string;
    link?: string;
    description?: string;
    image?: string;
    buttonText: string;
}

interface Props {
    tiles: Tile[];
}

const CTATileGrid = (props: Props) => {
    const onClickHandler = (link: string) => {
        return (e: React.MouseEvent) => {
            window.location.href = link;
        }
    }
    return (
        <div className="cta-tile-grid">
            {
                props.tiles.map((tile: Tile, index) =>  
                    <a key={tile.title} href={tile.link} className="cta-tile-grid__tile">
                        <img src={tile.image} alt={'cta tile background'}/>
                        <div className="content">
                            {tile.title && <h3 className="title">{tile.title}</h3> }
                            {tile.description && <p className="description">{tile.description}</p>}
                            {tile.link 
                                && <Button 
                                    id={`cta_tile_grid-tile_${index}`}
                                    ariaLabel={''} 
                                    button_type={BUTTON_TYPE.PRIMARY}
                                    text={tile.buttonText}
                                    onClick={onClickHandler(tile.link)}
                                    />
                            }
                        </div>
                    </a>
                )
            }
        </div>
    )
}

export default function render() {
    const elements = document.getElementsByClassName('cta-tile-grid-node');
    Array.prototype.map.call(elements, (element: HTMLElement) => {
        const children = Array.prototype.slice.call(element.children);
        const tiles: Tile[] = children.map((child: HTMLInputElement) => {
            return {
                title: child.dataset.title || '',
                link: child.dataset.link,
                image: child.dataset.image,
                description: child.dataset.description,
                buttonText: child.dataset.button_text || 'See More',
            }
        }, []);

        return ReactDOM.render(
            <CTATileGrid tiles={tiles} />,
            element,
        );
    });
}
